import { Controller } from '@hotwired/stimulus';

import Calendar from '@/modules/calendar';

export default class extends Controller {
  connect() {
    Calendar.init({ field: this.element });
  }
}
